import { useState, memo } from "react";
import { useDrivers } from "../../hooks/useDrivers";
import { Grid, Button, CircularProgress, Alert } from "@mui/material";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import SelectDriverModal from "../modals/SelectDriverModal";

const ReassignDeliveries = ({
  selectedDeliveries,
  isLoading,
  error,
  success,
  changeDriver,
  refetchDeliveries,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    drivers,
    loading: loadingDrivers,
    error: errorDrivers,
  } = useDrivers();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirmDriverSelection = async (driverId) => {
    try {
      await changeDriver({
        ids: selectedDeliveries,
        driverId,
      });

      handleCloseModal();
      alert(success);
    } catch (errorChangeDriver) {
      console.error(`Error al reasignar envíos: ${errorChangeDriver}, ahora se cargara error via la variable error: ${error}`);
      alert(`Error al reasignar envíos: ${error}`);
      handleCloseModal();
    } finally {
      window.location.reload();
    }
  };

  const isButtonDisabled =
    isLoading || loadingDrivers || selectedDeliveries.length === 0;

  return (
    <>
      <Grid item md={2} xs={6}>
        <Button
          variant="outlined"
          onClick={handleOpenModal}
          disabled={isButtonDisabled}
          startIcon={
            isLoading ? (
              <CircularProgress size={20} />
            ) : (
              <GroupAddIcon fontSize="small" />
            )
          }
        >
          {isLoading ? "Procesando..." : "Asignar a conductor"}
        </Button>
        {errorDrivers ||
          (error && (
            <Alert severity="error" sx={{ mt: 1, fontSize: "0.8rem" }}>
              {errorDrivers}
            </Alert>
          ))}
      </Grid>

      <SelectDriverModal
        open={isModalOpen}
        onClose={handleCloseModal}
        drivers={drivers}
        onConfirm={handleConfirmDriverSelection}
        loading={isLoading || loadingDrivers}
      />
    </>
  );
};

export default memo(ReassignDeliveries);
